import React from 'react';
import { RichTextEditor } from '@/components/ui/rich-text-editor';

interface RichTextFieldProps {
  label: string;
  required?: boolean;
  value: string;
  onChange: (_value: string) => void;
  placeholder?: string;
  error?: string;
}

export const RichTextField: React.FC<RichTextFieldProps> = ({
  label,
  required = false,
  value,
  onChange,
  placeholder,
  error
}) => {
  return (
    <>
      <label className="block text-sm font-medium text-gray-700 mb-2">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
      <div className={error ? '[&_.ql-container]:!border-red-500 [&_.ql-toolbar]:!border-red-500' : ''}>
        <RichTextEditor
          value={value || ''}
          onChange={onChange}
          placeholder={placeholder}
        />
      </div>
      {error && (
        <p className="text-red-500 text-sm mt-1">{error}</p>
      )}
    </>
  );
};

